import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import styled from 'styled-components'
import { Col, Row, Grid } from 'react-styled-flexboxgrid'

import Button from 'components/Atoms/Button'
import Image from 'components/Atoms/Image'
import Text from 'components/Atoms/Text'
import { Header } from 'components/Molecules/PayBySignage/Purchase'
import { Link } from 'i18n-web/i18next'
import { Subtitle } from 'components/Molecules/Purchase'
import { formatAddress } from 'i18n-web/formatters'
import { useTranslation } from 'i18n-web/i18next'

import Loading from './Loading'

const LotImage = styled(Image)`
  height: 300px;
  object-fit: cover;
`

const Content = styled(Grid)`
  padding-bottom: 35px;
  width: 100%;
`

const Description = styled.div`
  margin: 15px 0;
`

const ExtraInfo = styled(Text)`
  margin-top: 5px;
`

const Divisor = styled.hr`
  display: block;
  margin: 30px 0;
  width: 100%;
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.grayLight};
`

const LotButton = styled(Button)`
  display: block;
  & + & {
    margin-top: 20px;
  }
`

const Multiparking = ({
  eventLink,
  hasEvent,
  hasMonthly,
  hasOnDemand,
  isLoading,
  lot,
  monthlyLink,
  onDemandLink,
  onLotDetailsClick,
}) => {
  const { t } = useTranslation()

  if (isLoading) {
    return <Loading />
  }

  const { rawAddress, countryCode, name, mainPhoto, notes } = lot ?? {}

  return (
    <>
      <LotImage
        height={300}
        loading="lazy"
        src={mainPhoto?.image?.fallbackUrl}
      />
      <Header title={name} />
      <Content>
        <Row>
          <Col xs={12}>
            <Description>
              <Text className="small semiBold">
                {formatAddress(rawAddress, countryCode, 'full_inline')}
              </Text>
              {!isEmpty(notes) &&
                notes.split('\n').map(function (item, index) {
                  return (
                    <ExtraInfo key={index} className="small gray">
                      {item}
                    </ExtraInfo>
                  )
                })}
            </Description>
            <LotButton
              className="full uppercase inverted primaryBorder"
              onClick={onLotDetailsClick}>
              {t('multiparking.about')}
            </LotButton>
            <Divisor />
            <Subtitle className="uppercase">
              {t('multiparking.chooseParkingMethod')}
            </Subtitle>
            {hasOnDemand && (
              <Link href={onDemandLink}>
                <LotButton className="full uppercase">
                  {t('multiparking.hourly')}
                </LotButton>
              </Link>
            )}
            {hasEvent && (
              <Link href={eventLink}>
                <LotButton className="full uppercase">
                  {t('multiparking.event')}
                </LotButton>
              </Link>
            )}
            {hasMonthly && (
              <Link href={monthlyLink}>
                <LotButton className="full uppercase">
                  {t('multiparking.monthly')}
                </LotButton>
              </Link>
            )}
            {!hasOnDemand && !hasEvent && !hasMonthly && (
              <Text className="small gray" style={{ marginTop: 15 }}>
                {t('multiparking.noParkingMethodsAvailable')}
              </Text>
            )}
          </Col>
        </Row>
      </Content>
    </>
  )
}

Multiparking.propTypes = {
  eventLink: PropTypes.string,
  hasEvent: PropTypes.bool,
  hasMonthly: PropTypes.bool,
  hasOnDemand: PropTypes.bool,
  isLoading: PropTypes.bool,
  lot: PropTypes.object,
  monthlyLink: PropTypes.string,
  onDemandLink: PropTypes.string,
  onLotDetailsClick: PropTypes.func,
}

export default Multiparking
